import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-8">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground font-inter">
        {items.map((item, i) => (
          <li key={item.to} className="flex items-center gap-2">
            {i > 0 && <span aria-hidden="true">›</span>}
            {i === items.length - 1 ? (
              <span aria-current="page" className="text-foreground">{item.label}</span>
            ) : (
              <Link to={item.to} className="hover:text-primary transition-colors">{item.label}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}